// assets/brinde-kit.js
// Brinde do kit (22/10/2026, Felipe): comprou o kit, o kit de brindes entra sozinho no carrinho, na mesma quantidade;
// tirou o kit, o brinde sai junto. Quem zera o preco do brinde e o desconto automatico "Compre X, Leve Y" da Shopify
// (um por kit). Se o brinde entrar cobrando (desconto desligado ou ausente), o script tira o brinde e para de mexer
// naquele par ate a pagina recarregar: nunca deixa o cliente pagar pelo brinde.
// Configuracao em Tema > Configuracoes > Cicatribem - Brinde do kit (pares "kit > kit-de-brindes").
// Gatilhos: carga da pagina (se o carrinho tem itens), qualquer chamada a /cart/add|change|update|clear (fetch ou XHR,
// de qualquer script), mutation da API da vitrine (carrinho lateral do OCU) e o "Finalizar compra".
// Limites: link direto para o checkout (/cart/<id>:1) e botao de pagamento rapido pulam o carrinho, entao nao poem o brinde.
(function () {
  'use strict';
  var cfg = window.cbBrindeKitCfg;
  if (!cfg || !cfg.pares || !window.fetch) return;

  var RAIZ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var brindeDoKit = {};
  String(cfg.pares).split(String.fromCharCode(10)).join(';').split(';').forEach(function (par) {
    var p = par.split('>');
    if (p.length !== 2) return;
    var kit = p[0].trim();
    var brinde = p[1].trim();
    if (kit && brinde) brindeDoKit[kit] = brinde;
  });
  if (!Object.keys(brindeDoKit).length) return;

  var fetchOriginal = window.fetch.bind(window);
  var variantes = {};
  var cobrando = {}; // handle do brinde que entrou com preco: nao insiste nele nesta pagina
  var fila = Promise.resolve();
  var espera = null;

  function pedir(caminho, corpo) {
    return fetchOriginal(RAIZ + caminho, {
      method: corpo ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: corpo ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' },
      body: corpo ? JSON.stringify(corpo) : undefined
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || ('HTTP ' + r.status));
        return d;
      });
    });
  }

  // id da variante do brinde pelo endereco (os brindes sao ocultos, mas /products/<handle>.js responde)
  function idDaVariante(handle) {
    if (!variantes[handle]) {
      variantes[handle] = pedir('products/' + handle + '.js').then(function (p) {
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        return String(v.id);
      });
      variantes[handle].catch(function () { delete variantes[handle]; });
    }
    return variantes[handle];
  }

  // Quantos brindes de cada tipo o carrinho deve ter: soma das quantidades dos kits do par
  function brindesDevidos(cart) {
    var devidos = {};
    Object.keys(brindeDoKit).forEach(function (kit) {
      var brinde = brindeDoKit[kit];
      if (devidos[brinde] === undefined) devidos[brinde] = 0;
    });
    (cart.items || []).forEach(function (i) {
      var brinde = brindeDoKit[i.handle];
      if (brinde && !cobrando[brinde]) devidos[brinde] += i.quantity;
    });
    Object.keys(cobrando).forEach(function (brinde) { devidos[brinde] = 0; });
    return devidos;
  }

  // Uma rodada: le o carrinho e acerta as linhas de brinde numa chamada so (update.js com chaves de linha e ids).
  function rodada() {
    return pedir('cart.js').then(function (cart) {
      var devidos = brindesDevidos(cart);
      var brindes = Object.keys(devidos);
      return Promise.all(brindes.map(function (brinde) {
        var linhas = (cart.items || []).filter(function (i) { return i.handle === brinde; });
        var tem = linhas.reduce(function (s, i) { return s + i.quantity; }, 0);
        if (tem === devidos[brinde]) return null;
        if (linhas.length) {
          // acerta na primeira linha e zera as outras
          var mudancas = {};
          linhas.forEach(function (i, n) { mudancas[i.key] = n === 0 ? devidos[brinde] : 0; });
          return mudancas;
        }
        return idDaVariante(brinde).then(function (id) {
          var m = {};
          m[id] = devidos[brinde];
          return m;
        });
      })).then(function (lista) {
        var updates = {};
        lista.forEach(function (m) {
          if (m) Object.keys(m).forEach(function (k) { updates[k] = m[k]; });
        });
        if (!Object.keys(updates).length) return { cart: cart, mudou: false };
        return pedir('cart/update.js', { updates: updates }).then(conferirPreco);
      });
    });
  }

  // Brinde que ficou cobrando (sem o "Compre X, Leve Y" valendo): sai do carrinho e o par fica parado nesta pagina.
  function conferirPreco(cart) {
    var pagos = (cart.items || []).filter(function (i) {
      var ehBrinde = Object.keys(brindeDoKit).some(function (k) { return brindeDoKit[k] === i.handle; });
      return ehBrinde && i.final_line_price > 0;
    });
    if (!pagos.length) return { cart: cart, mudou: true };
    var updates = {};
    pagos.forEach(function (i) {
      cobrando[i.handle] = true;
      updates[i.key] = 0;
      if (window.console) console.warn('[brinde-kit] brinde cobrando, retirado (confira o desconto Compre X, Leve Y):', i.handle);
    });
    return pedir('cart/update.js', { updates: updates }).then(function (novo) { return { cart: novo, mudou: true }; });
  }

  // Redesenha o carrinho lateral (tema e OCU) ou recarrega a pagina do carrinho; resolve quando terminar.
  function atualizarTela() {
    if (cfg.paginaCarrinho) {
      window.location.reload();
      return Promise.resolve();
    }
    try {
      if (typeof window.UPDATE_CART === 'function') window.UPDATE_CART();
    } catch (e) { /* carrinho do OCU ausente ou com erro: o do tema segue */ }
    var mc = window.cicatribemMinicart;
    return mc && typeof mc.recarregar === 'function' ? mc.recarregar() : Promise.resolve();
  }

  // Enfileira uma rodada (nunca duas ao mesmo tempo); a promessa nunca rejeita.
  function sincronizar() {
    fila = fila.then(rodada).then(function (r) {
      if (!r || !r.mudou) return r;
      return atualizarTela().then(function () { return r; });
    }).catch(function (e) {
      if (window.console) console.warn('[brinde-kit]', e);
      return null;
    });
    return fila;
  }

  function agendar() {
    clearTimeout(espera);
    espera = setTimeout(sincronizar, 150);
  }

  // corpo: texto da requisicao quando se sabe (fetch); undefined quando nao (XHR, Request)
  function mexeNoCarrinho(url, corpo) {
    url = String(url || '');
    if (url.indexOf('/cart/add') > -1 || url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1 ||
        url.indexOf('/cart/clear') > -1) return true;
    // o carrinho lateral do OCU mexe nas linhas pela API da vitrine (graphql.json, mutations)
    return url.indexOf('graphql.json') > -1 && (corpo === undefined || String(corpo).indexOf('mutation') > -1);
  }

  window.fetch = function (entrada, opcoes) {
    var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
    var corpo = opcoes && typeof opcoes.body === 'string' ? opcoes.body : undefined;
    var p = fetchOriginal(entrada, opcoes);
    if (mexeNoCarrinho(url, corpo)) p.then(agendar, function () {});
    return p;
  };
  var abrirXhr = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    if (mexeNoCarrinho(url)) this.addEventListener('loadend', agendar);
    return abrirXhr.apply(this, arguments);
  };

  // Rede de seguranca no "Finalizar compra" (tema e OCU): acerta os brindes antes de ir ao checkout. Espera no maximo
  // 2,5 s; qualquer erro libera o clique na hora.
  var SELETOR_CHECKOUT = 'a[href="/checkout"], a[href^="/checkout?"], [name="checkout"], .ocu-checkout-button';
  var liberado = false;
  document.addEventListener('click', function (ev) {
    var alvo = null;
    try {
      alvo = !liberado && ev.target && ev.target.closest ? ev.target.closest(SELETOR_CHECKOUT) : null;
    } catch (e) {
      alvo = null;
    }
    if (!alvo) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    var limite = new Promise(function (r) { setTimeout(r, 2500); });
    Promise.race([sincronizar(), limite]).then(function () {
      liberado = true;
      setTimeout(function () { liberado = false; }, 1500);
      if (alvo.isConnected) alvo.click();
      else window.location.href = RAIZ + 'checkout';
    });
  }, true);

  window.cbBrindeKit = { sincronizar: sincronizar };

  if (cfg.itens > 0) {
    if (document.readyState === 'complete') sincronizar();
    else window.addEventListener('load', sincronizar);
  }
})();
